import { render, staticRenderFns } from "./QuickEditForTable.vue?vue&type=template&id=daf51232&scoped=true&"
import script from "./QuickEditForTable.vue?vue&type=script&lang=ts&"
export * from "./QuickEditForTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuickEditForTable.vue?vue&type=style&index=0&id=daf51232&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf51232",
  null
  
)

export default component.exports